import { locationIdFormat } from "@redotech/redo-inventory-id";
import { consolidationCartonParcelInputSchema } from "@redotech/redo-merchant-fulfillment-rpc-packing-station/packing-station";
import { cartonDisplayIdentifiersSchema } from "@redotech/redo-warehouse-common/carton-display-identifier";
import { consolidationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";
import { cartonOperationIdSchema } from "./carton-operation";

export const createCartons = {
  name: "createCartons" as const,
  mutates: true,
  input: z
    .object({
      requestId: z.string().uuid(),
      quantity: z.number().int().min(1).max(100),
      displayIdentifiers: cartonDisplayIdentifiersSchema.optional(),
      parcel: consolidationCartonParcelInputSchema.nullable().optional(),
      destination: z.discriminatedUnion("type", [
        z.object({
          type: z.literal("warehouse"),
          locationId: locationIdFormat.schema,
        }),
        z.object({
          type: z.literal("consolidation"),
          consolidationId: consolidationIdFormat.schema,
        }),
      ]),
    })
    .refine(
      (input) =>
        input.displayIdentifiers === undefined ||
        input.displayIdentifiers.length === input.quantity,
      {
        message: "Provide one display identifier per carton",
        path: ["displayIdentifiers"],
      },
    ),
  output: z.object({ cartonIds: z.array(cartonOperationIdSchema) }),
};
